// extracted by mini-css-extract-plugin
module.exports = {"addToCartWrapper":"KdW0Ht","addToCart":"uq40TF"};